/*eslint-disable*/
// import TimelineLite from 'flickity'
// import TweenLite from 'flickity'

export default intro => {
  const tween = new TimelineLite()

  tween.add(
    TweenLite.to(['.moodboard-1_container', '.moodboard-2_container', '.moodboard-3_container'], 1, {
      transform: 'translate3d(-200vw,0,0)',
      ease: Linear.easeNone
    })
  )

  const controller = new ScrollMagic.Controller()

  let calculatedTriggerHook
  if (window.innerWidth > 1180) {
    calculatedTriggerHook = ((86 + 50) / window.innerHeight)
  } else {
    calculatedTriggerHook = ((79 + 56) / window.innerHeight)
  }

  let calculatedDuration
  if (window.innerWidth > 1180) {
    calculatedDuration = 7000
  } else {
    calculatedDuration = 2000
  }

  const scene = new ScrollMagic.Scene({
    triggerElement: '.tee-intro_container',
    duration: calculatedDuration,
    triggerHook: calculatedTriggerHook
  })
    .setTween(tween)
    // .addIndicators()
    .setPin('.tee-intro_container')
    .addTo(controller)
  scene.offset(320)

  $(window).on('resize', function () {
    scene.refresh()
    console.log('refresh')
    // tween.progress(0)
    console.log('reset')

    // add in tween updating or new tween function

    // scene.setTween(tween);
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/the-every-edit-intro.js